import React from 'react';

/**
 * Grade de debug 4x6 para testar layouts
 * Cada quadrado representa uma proporção da tela
 */
export default function DebugGrid({ show = false }) {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        pointerEvents: 'none',
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridTemplateRows: 'repeat(4, 1fr)',
        gap: '2px'
      }}
    >
      {/* Renderiza 24 quadrados (4x6) */}
      {Array.from({ length: 24 }, (_, index) => (
        <div
          key={index}
          style={{
            border: '1px solid rgba(255, 0, 0, 0.3)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: 'rgba(255, 0, 0, 0.2)',
            fontWeight: 'bold'
          }}
        >
          {index + 1}
        </div>
      ))}
    </div>
  );
}
